import { render } from "./Project2View.vue?vue&type=template&id=07f93428&scoped=true&ts=true"
import script from "./Project2View.vue?vue&type=script&lang=ts"
export * from "./Project2View.vue?vue&type=script&lang=ts"

import "./Project2View.vue?vue&type=style&index=0&id=07f93428&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f93428"]])

export default __exports__